@if (hasFilters()) {
  <button type="button" (click)="onClicked()" class="btn btn-primary">Effacer</button>
}
